module.exports = __webpack_public_path__ + "img/109.3.712b9d6f.png";